import { IAuthAction, IAuthActions, IAuthState } from './models';
import axios from 'axios';
import { push } from 'react-router-redux';
import * as api from '../../data/api/api';
import { ICustomer } from '../../data/api/models';
import * as moment from 'moment';

export const LOGIN = 'b2c/auth/LOGIN';
export const LOGIN_FAILURE = 'b2c/auth/LOGIN_FAILURE';
export const LOGOUT = 'b2c/auth/LOGOUT';
export const UPDATE = 'b2c/auth/UPDATE';
export const RELOAD = 'b2c/auth/RELOAD';
export const FORGOTTEN_PASSWORD = 'b2c/auth/FORGOTTEN_PASSWORD';
export const CREATE_ACCOUNT = 'b2c/auth/CREATE_ACCOUNT';
export const PASSWORD_RESET = 'b2c/auth/PASSWORD_RESET';
export const RESET = 'b2c/auth/RESET';
export const UNAUTHENTICATE = 'b2c/auth/UNAUTHENTICATE';
export const HAS_ERROR = 'b2c/auth/HAS_ERROR';

const initialState: IAuthState = {
  isAuthenticated: false,
  loginFailed: false,
  resetPassword: false,
  createAccount: false,
  customer: null,
  hasPasswordBeenReset: false,
  error: {
    login: [],
    reset: [],
    update: [],
  },
};

export function reducer(state: IAuthState = initialState, action: IAuthAction): IAuthState {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        isAuthenticated: true,
        resetPassword: false,
        customer: action.payload,
        loginFailed: false,
      };

    case LOGIN_FAILURE:
      return {
        ...state,
        loginFailed: true,
      };

    case RELOAD:
      return {
        ...state,
        customer: action.payload,
      };

    case UNAUTHENTICATE:
      return {
        ...state,
        isAuthenticated: false,
        resetPassword: false,
      };

    case LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        resetPassword: false,
        customer: null,
      };

    case UPDATE:
      return {
        ...state,
        customer: action.payload,
      };

    case FORGOTTEN_PASSWORD:
      return {
        ...state,
        resetPassword: true,
      };

    case CREATE_ACCOUNT:
      return {
        ...state,
        resetPassword: false,
        createAccount: true,
      };

    case PASSWORD_RESET:
      return {
        ...state,
        resetPassword: false,
        hasPasswordBeenReset: true,
      };

    case HAS_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case RESET:
      return {
        ...state,
        hasPasswordBeenReset: false,
        error: null,
      };

    default:
      return state;
  }
}

const login = (username, password, dob) => (dispatch) => {
  const data = {
    username,
    password,
    dob,
  };

  return axios.post('/auth/login', data, { baseURL: '' })
    .then((response) => {
      axios.defaults.headers.common = {
        ...axios.defaults.headers.common,
        Authorization: 'Bearer ' + response.data.access_token,
      };

      return api.getCustomer().then((customer: ICustomer) => {
        dispatch({ type: LOGIN, payload: customer });
      });
    })
    .catch((error) => {
      dispatch({ type: LOGIN_FAILURE });
      console.error(error);
    });
};

const unauthenticate = (): IAuthAction => ({ type: UNAUTHENTICATE });

const logout = (redirect = true) => (dispatch) => {
  dispatch(unauthenticate());

  return axios.post('/auth/logout', {}, { baseURL: '' })
    .then(() => {
      delete axios.defaults.headers.common.Authorization;

      if (redirect) {
        dispatch(push('/auth/login'));
      }

      setTimeout(() => {
        dispatch({ type: LOGOUT });
      }, 1000);
    });
};

const forgottenPassword = (email, requestItems, scheme, host) => (dispatch) => {
  return api.passwordReminder(email, requestItems, scheme, host)
    .then(() => {
      dispatch({ type: FORGOTTEN_PASSWORD });
      return true;
    });
};

const createAccount = (email, requestItems, scheme, host) => (dispatch) => {
  return api.accountCreator(email, requestItems, scheme, host)
    .then(() => {
      dispatch({ type: CREATE_ACCOUNT });
      return true;
    });
};

const resetPassword = (token, values) => (dispatch) => {
  const dob = moment(values.dob, 'DD/MM/YYYY').format('YYYY-MM-DD');
  return api.resetPassword(token, values)
    .then(() => {
      dispatch({ type: PASSWORD_RESET });
      dispatch(push('/auth/login'));
    })
    .then(() => {
      dispatch(login(values.email, values.password, dob))
        .then(() => {
          dispatch(push('/account/summary'));
          dispatch({ type: RESET });
        })
        .catch((error) => {
          dispatch({ type: HAS_ERROR, payload: { reset: error.response.data.errors } });
        });
    })
    .catch((error) => {
      dispatch({ type: HAS_ERROR, payload: { reset: error.response.data.errors } });
    });
};

const update = (customer: ICustomer) => (dispatch) => {
  return api.updateCustomer(customer)
    .then((customer: ICustomer) => {
      dispatch({ type: UPDATE, payload: customer });
    })
    .catch((error) => {
      dispatch({ type: HAS_ERROR, payload: { update: error.response.data.errors } });
    });
};

const reloadCustomer = () => (dispatch) => {
  return api.getCustomer().then((customer: ICustomer) => {
    dispatch({ type: RELOAD, payload: customer });
  });
};

export const actions: IAuthActions = {
  login,
  logout,
  update,
  forgottenPassword,
  createAccount,
  resetPassword,
  reloadCustomer,
};
